import { useState } from "react";
import { ImageUpload } from "./ImageUpload";
import { Field, Toggle } from "./Field";

export const SponsorForm = ({ initial, onSubmit, busy }) => {
  const [f, setF] = useState({ name: "", logo: "", url: "", tier: "Partner", confirmed: false, ...initial });
  const set = (k) => (e) => setF({ ...f, [k]: e?.target ? e.target.value : e });
  return (
    <form onSubmit={(e) => { e.preventDefault(); onSubmit(f); }} className="grid gap-4" data-testid="sponsor-form">
      <Field label="Sponsor name *"><input required data-testid="sf-name" className="admin-input" value={f.name} onChange={set("name")} /></Field>
      <ImageUpload value={f.logo} onChange={set("logo")} testId="sf-logo" label="Logo" />
      <Field label="Website"><input type="url" data-testid="sf-url" className="admin-input" value={f.url} onChange={set("url")} placeholder="https://" /></Field>
      <Field label="Tier"><input data-testid="sf-tier" className="admin-input" value={f.tier} onChange={set("tier")} placeholder="Presenting, Partner…" /></Field>
      <Toggle label="Confirmed — show on website" checked={f.confirmed} onChange={set("confirmed")} testId="sf-confirmed" />
      <button data-testid="sf-submit" disabled={busy} className="btn-primary justify-center">{busy ? "Saving…" : "Save Sponsor"}</button>
    </form>
  );
};
